import Head from 'next/head'

import AuthenticationLayout from '@/components/layouts/Authentication'
import RegisterForm from '@/components/RegisterForm'

export default function Register(): JSX.Element {
	return (
		<>
			<Head>
				<title key="page-title">Create Account | Pace International</title>
			</Head>

			<div className="mx-auto w-full max-w-xs text-gray-800 bg-white shadow-card rounded-lg pt-3 px-3 pb-6 sm:max-w-md md:max-w-2xl md:p-8 lg:max-w-3xl xl:max-w-4xl">
				<RegisterForm title="Create your Pace account" />
			</div>
		</>

	)
}

Register.Layout = AuthenticationLayout
